"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M994.034 1226.26c-18.796 27.296-49.269 27.3-68.067 0L574.893 716.424C556.096 689.128 567.713 667 600.852 667h718.297c33.133 0 44.757 22.125 25.959 49.424L994.034 1226.26z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMiniArrowDown =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconMiniArrowDown, _Component);

  function IconMiniArrowDown() {
    (0, _classCallCheck2.default)(this, IconMiniArrowDown);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconMiniArrowDown).apply(this, arguments));
  }

  (0, _createClass2.default)(IconMiniArrowDown, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconMiniArrowDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconMiniArrowDown.displayName = "IconMiniArrowDown";
  return IconMiniArrowDown;
}(_react.Component);

exports.default = IconMiniArrowDown;
IconMiniArrowDown.glyphName = 'mini-arrow-down';
IconMiniArrowDown.variant = 'Line';
IconMiniArrowDown.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);